import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const tableLogService = {
    getAll,
    getAllTableLogs,
    addTableLog,
    updateTableLog,
    deleteTableLog,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/table-logs/getAllTableLogs/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllTableLogs() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-logs/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addTableLog(newTableLog) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newTableLog),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-logs/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateTableLog(tableLogItem, tableLogId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(tableLogItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-logs/update/${tableLogId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteTableLog(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/table-logs/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
